import React from 'react';
import { Translate } from 'react-redux-i18n';
import HeaderComponent from '../components/table/header/headerComponent';

import ParamsComponent from '../components/layout/params';
import SocialMedia from '../components/layout/socialMedia';
import ParamsApp from '../components/layout/paramsApp';

class LayoutPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      params: 'params',
    };
  }

  render() {
    const Screen = {
      params: <ParamsComponent />,
      app: <ParamsApp />,
      socialNetwork: <SocialMedia />,
    };

    return (
      <div className="main-table">
        <div className="main-header-table">
          <HeaderComponent
            title="Layouts"
          />
          <div className="btn-group" role="group" aria-label="Basic example">
            <button
              type="button"
              className={this.state.params === 'params' ? 'btn btn-secondary dark-gray' : 'btn btn-secondary'}
              onClick={() => this.setState({ params: 'params' })}
            >
              <Translate value="params" />
            </button>
            <button
              type="button"
              className={this.state.params === 'app' ? 'btn btn-secondary dark-gray' : 'btn btn-secondary'}
              onClick={() => this.setState({ params: 'app' })}
            >
              <Translate value="APP" />
            </button>
            <button
              type="button"
              className={this.state.params === 'socialNetwork' ? 'btn btn-secondary dark-gray' : 'btn btn-secondary'}
              onClick={() => this.setState({ params: 'socialNetwork' })}
            >
              <Translate value="socialMedia" />
            </button>
          </div>
          <div className="margin-top-20 ">
            {
              Screen[this.state.params]
            }
          </div>
        </div>

      </div>
    );
  }
}
export default LayoutPage;
